var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMomo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1118_1056)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1118_1056)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    transform: "translate(0.600098)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8974 0H3.3028C1.81631 0 0.600098 1.21622 0.600098 2.7027V37.2973C0.600098 38.7838 1.81631 40 3.3028 40H37.8974C39.3839 40 40.6001 38.7838 40.6001 37.2973V2.7027C40.6001 1.21622 39.3839 0 37.8974 0Z",
    fill: "#A50064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.276 18.7838C31.4516 18.7838 34.0192 16.2162 34.0192 13.0405C34.0192 9.86487 31.4516 7.2973 28.276 7.2973C25.1003 7.2973 22.5327 9.86487 22.5327 13.0405C22.5327 16.2162 25.1003 18.7838 28.276 18.7838ZM28.276 10.5946C29.6273 10.5946 30.7219 11.6892 30.7219 13.0405C30.7219 14.3919 29.6273 15.4865 28.276 15.4865C26.9246 15.4865 25.83 14.3919 25.83 13.0405C25.83 11.6892 26.9246 10.5946 28.276 10.5946Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.276 21.2703C25.1003 21.2703 22.5327 23.8378 22.5327 27.0135C22.5327 30.1892 25.1003 32.7568 28.276 32.7568C31.4516 32.7568 34.0192 30.1892 34.0192 27.0135C34.0192 23.8378 31.4516 21.2703 28.276 21.2703ZM28.276 29.4595C26.9246 29.4595 25.83 28.3649 25.83 27.0135C25.83 25.6622 26.9246 24.5676 28.276 24.5676C29.6273 24.5676 30.7219 25.6622 30.7219 27.0135C30.7219 28.3649 29.6273 29.4595 28.276 29.4595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5731 21.2703C15.6001 21.2703 14.7082 21.5946 13.992 22.1351C13.2758 21.5946 12.3704 21.2703 11.4109 21.2703C9.03253 21.2703 7.1001 23.2027 7.1001 25.5811V32.7703H10.3974V25.5405C10.3974 25 10.8298 24.5676 11.3704 24.5676C11.9109 24.5676 12.3433 25 12.3433 25.5405V32.7568H15.6406V25.5405C15.6406 25 16.0731 24.5676 16.6136 24.5676C17.1542 24.5676 17.5866 25 17.5866 25.5405V32.7568H20.8704V25.5676C20.8704 23.2027 18.9514 21.2703 16.5731 21.2703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5732 7.2973C15.6002 7.2973 14.7083 7.62163 13.9921 8.16217C13.2759 7.62163 12.3705 7.2973 11.411 7.2973C9.0191 7.2973 7.08667 9.22973 7.08667 11.6081V18.7838H10.384V11.5676C10.384 11.027 10.8164 10.5946 11.3569 10.5946C11.8975 10.5946 12.3299 11.027 12.3299 11.5676V18.7838H15.6272V11.5676C15.6272 11.027 16.0596 10.5946 16.6002 10.5946C17.1407 10.5946 17.5732 11.027 17.5732 11.5676V18.7838H20.8705V11.6081C20.8705 9.22973 18.9515 7.2973 16.5732 7.2973Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1118_1056"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.600098,
    width: 40,
    height: 40,
    rx: 6,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1118_1056"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.600098)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMomo);
export default __webpack_public_path__ + "static/media/Momo.25fb245ae4aab8eeffd070bcb277cd71.svg";
export { ForwardRef as ReactComponent };